import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ts273nz6z4: FaireBrandEntity = {
  token: "b_ts273nz6z4",
  type: "brand",
  name: "Joni McKown Art",
  avatarUrl:
    "https://cdn.faire.com/fastly/e97ae7ab628f92c4b65bd7bc799744d12fbff8610ee950b385856b7f1a89c0fa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1dd12695c7bbf84d62232b1c1f2c891b315f524cae8b491c77f210c31cb6e6aa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e97ae7ab628f92c4b65bd7bc799744d12fbff8610ee950b385856b7f1a89c0fa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1dd12695c7bbf84d62232b1c1f2c891b315f524cae8b491c77f210c31cb6e6aa.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Joni McKown Art creates and sells custom note cards, mahjong mats, cocktail napkins and prints based on original watercolor paintings and graphic designs. We also create artwork for brand and retail marketing and advertising (social media, website, note cards, invitations, pamphlets, wine bottle labels and more). Joni also illustrates coloring books of cities and premier hotels (St. Regis, Four Seasons, etc.) for the Color Our Town series that are sold in gift shops, bookstores, and toy stores nationwide. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:56.312Z",
    importedBy: "entity-db-cli",
  },
};
